import { render, staticRenderFns } from "./orderPaymentMethod.vue?vue&type=template&id=44b5d0cf&scoped=true"
import script from "./orderPaymentMethod.vue?vue&type=script&lang=js"
export * from "./orderPaymentMethod.vue?vue&type=script&lang=js"
import style0 from "./orderPaymentMethod.vue?vue&type=style&index=0&id=44b5d0cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b5d0cf",
  null
  
)

export default component.exports